import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Grid,FormControl,InputLabel,Select,OutlinedInput, IconButton, Toolbar } from '@material-ui/core';
import { NavigateNext, NavigateBefore, Print as PrintIcon } from '@material-ui/icons';


const useStyles = makeStyles(theme => ({
  root: {marginBottom: '15px'},
  row: {
    height: '42px',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  period: {
    display: 'flex',
    alignItems: 'center',  
  }
}));

const useStylesInput = makeStyles(theme => ({
  input: { textAlign: 'center'}
}));

const SheduleToolbar = props => {
  const { rooms, currentRoom, currentPeriodFilter, periods, periodString, prevBtnDis, nextBtnDis, onChangeRoom, onChangePeriod, onClickNextPeriod, onClickPrevPeriod } = props;

  const classes = useStyles();
  const classesInput = useStylesInput();

  return (
    <div
      className={classes.root}
    >
      <Grid container spacing={4}>
        <Grid item lg={6} xs={12}>
          <div className={classes.row}>
            <FormControl variant="outlined" size="small"  style={{ minWidth: '150px' }} >
              <InputLabel shrink htmlFor="selectId">Помещение</InputLabel> 
              <Select
                native
                value={currentRoom}
                onChange={(event)=>onChangeRoom(event.target.value)}
                label="Помещение"
                inputProps={{
                  label: 'Помещение',
                  id: 'selectId',
                }}
              >
                {rooms.map(room => (
                  <option key={room.guid} value={room.guid}>{room.name}</option>
                ))}
              </Select>
            </FormControl>

            <FormControl variant="outlined" size="small" style={{ marginLeft: '1rem' }}>
              <InputLabel htmlFor="outlined-period-native-simple">Период</InputLabel> 
              <Select
                native
                value={currentPeriodFilter}
                onChange={(event)=>onChangePeriod(event.target.value)}
                label="Период"
                inputProps={{
                  name: 'Период',
                  id: 'outlined-period-native-simple',
                }}
              >
                 {periods.map(period => (
                  <option key={period.id} value={period.id}>{period.name}</option>
                ))}
              </Select>
            </FormControl>
            
            </div>
        </Grid>
        <Grid item lg={6} xs={12}>
          <div className={classes.row}>
              <div className={classes.period}>
                <IconButton variant='outlined' disabled={prevBtnDis} onClick={() => onClickPrevPeriod()}>
                  <NavigateBefore fontSize="large" />
                </IconButton>
              
                <FormControl variant="outlined" size="small">
                  <OutlinedInput 
                    value={periodString} 
                    readOnly 
                    classes={classesInput}               
                    />  
                </FormControl>

                <IconButton variant='outlined' disabled={nextBtnDis} onClick={() => onClickNextPeriod()}>
                  <NavigateNext fontSize="large"  />
                </IconButton>
              </div>
              
            </div>
        </Grid>
      </Grid>
    </div>
  );
};

SheduleToolbar.propTypes = {
  rooms: PropTypes.array,
  currentRoom: PropTypes.string,
  currentPeriodFilter: PropTypes.string,
  periods: PropTypes.array,
  periodString: PropTypes.string,
  prevBtnDis: PropTypes.bool,
  nextBtnDis: PropTypes.bool,
  onChangeRoom: PropTypes.func,
  onChangePeriod: PropTypes.func,
  onClickNextPeriod: PropTypes.func,
  onClickPrevPeriod: PropTypes.func,
};

export default SheduleToolbar;
